import { createAsyncThunk } from '@reduxjs/toolkit';

import { ContentNugget } from '@backrs_ui/common-ui';

import { fetchWrapper as fetch } from '@backrs_ui/grow-ui/src/utils/fetch/fetchWrapper';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export const fetchContentNuggetsByCompetencyId = createAsyncThunk(
  'contentCompetency/fetchContentNuggetsByCompetencyId',
  async (params: { competency_id: number }, { rejectWithValue }) => {
    try {
      const response = await fetch(
        `${ENVIRONMENT_URL}/content-nugget?competency_id=${params.competency_id}`,
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentNugget[];
    } catch (error) {
      return rejectWithValue(`Failed to fetch content competencies with error: ${error}`);
    }
  },
);
